// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ETW2","largestCol":"styles_largestCol__1uXz0","smallestCol":"styles_smallestCol__3qhRv"};